// third-party
import { createSlice } from "@reduxjs/toolkit";

// project imports
import http from "../../http-common";
import { dispatch } from "../index";
// ----------------------------------------------------------------------

const initialState = {
  error: null,
  optionsList: [],
  optionOne: [],
  optionSuccess: [],
  optionValidation: [],

};

const slice = createSlice({
  name: "optionsDados",
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = action.payload;
    },

    getOptionSuccess(state, action) {
      state.optionSuccess = action.payload;
    },
    getOptionSuccessValidation(state, action) {
      state.optionValidation = action.payload;
    },

    getOptionListGetValue(state, action) {
      state.optionsList = action.payload;
    },


    // GET optionsList
    getOptions(state, action) {
      state.optionsList = action.payload;
    }
  },
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------
export function optionEnregistrer(data) {
  return async () => {
    try {
      const response = await http.post("/options", data);

      dispatch(slice.actions.getOptionSuccess(response.data));
      
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
};
export function optionListFx(universityID, facultyID, departmentID, promotionID) {
  return async () => {
    try {
      const response = await http.get(`/options?universityID=${universityID}&facultyID=${facultyID}&departmentID=${departmentID}&promotionID=${promotionID}`);
      dispatch(slice.actions.getOptionListGetValue(response.data));
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}
export function optionValidadeCode(id, tipoPedido, dadoPesquisa, facultyID, departmentID, promotionID) {
  return async () => {
    try {
      const response = await http.get(`/options/${id}?tipoPedido=${tipoPedido}&dadoPesquisa=${dadoPesquisa}&facultyID=${facultyID}&departmentID=${departmentID}&promotionID=${promotionID}`);
      dispatch(slice.actions.getOptionSuccessValidation(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
